/**
 * OwnersPage — Управление владельцами бизнеса (для Super Admin)
 */
export function OwnersPage(): React.JSX.Element {
  const owners = [
    { id: 1, name: 'Владимир В.', business: 'Салон «Элегант»', sub: 'PRO', expires: '14.06.2026', status: 'active' },
    { id: 2, name: 'Артем М.', business: 'Barber Shop No.1', sub: 'FREE', expires: '-', status: 'active' },
    { id: 3, name: 'Иван И.', business: 'Кофейня "Зерно"', sub: 'PRO', expires: '20.05.2026', status: 'blocked' },
  ];

  return (
    <div className="p-1">
      <h1>👥 Владельцы бизнеса</h1>
      
      <div className="section-title">Всего: {owners.length}</div>

      {owners.map(owner => (
        <div key={owner.id} className="booking-item" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '15px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="booking-info">
              <h4>{owner.business}</h4>
              <p>Владелец: {owner.name}</p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div className="time-val">{owner.sub}</div>
              <div className={`status-badge ${owner.status === 'active' ? 'status-confirmed' : ''}`} 
                   style={{ color: owner.status === 'blocked' ? '#FF3B30' : '', background: owner.status === 'blocked' ? 'rgba(255,59,48,0.1)' : '' }}>
                {owner.status === 'active' ? 'Активен' : 'Заблокирован'}
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <button className="card" style={{ flex: 1, padding: '10px', fontSize: '12px', backgroundColor: 'var(--tg-btn)', color: 'white' }}>
              Изменить тариф
            </button>
            <button 
              className="card" 
              style={{ flex: 1, padding: '10px', fontSize: '12px', color: owner.status === 'blocked' ? '#34C759' : '#FF3B30' }}
            >
              {owner.status === 'blocked' ? 'Разблокировать' : 'Блокировать'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
